<template>
    <div>
        <button class="btn btn-success" @click="openModal('create-video-modal')">
            <i class="fa fa-upload"></i> Upload Video
        </button>
        <modal id="create-video-modal">
            <template slot="title">New Video</template>
            <template slot="body">
                <field-input v-model="form.name" placeholder="Name"></field-input>
                <field-text v-model="form.description" placeholder="Description"></field-text>
                <field-file v-model="form.path" placeholder="File"></field-file>
                <field-input v-model="form.playtime" placeholder="Playtime (In Minutes)"></field-input>
                <field-datetime v-model="form.published_at" :with-time="false" :clear-button="true" :emit-null="true" label="Publish Date"></field-datetime>
            </template>
            <template slot="footer">
                <button class="btn btn-default" type="button" @click="closeModal('create-video-modal')">Close</button>
                <button class="btn btn-success" type="button" @click="save()" :disabled="form.isSubmitted">
                    <span v-if="form.isSubmitted">
                        <i class="fa fa-spin fa-spinner"></i> Uploading File...
                    </span>
                    <span v-else>
                        Save
                    </span>
                </button>
            </template>
        </modal>
    </div>
</template>
<script>
    export default {

        props: {
            serie: {
                required: true,
                type: Object,
            }
        },

        data() {
            return {
                form: new Form({
                    serie_id: this.serie.id,
                    name: '',
                    description: '',
                    path: '',
                    playtime: 5,
                    published_at: null,
                }).uploadFiles().dontClear()
            }
        },

        methods: {
            save() {
                this.form.post(`/training/series/${this.serie.slug}/videos`).then(response => {
                    Toast.success(`Video Uploaded Successfully!`)
                    this.refreshPage();
                }).catch(errors => {
                    Alert.error(errors.first())
                })
            }
        },
    }
</script>
